/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/organisation-program.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const OrganisationProgramRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        Program: oldRecord.Name,
        Name: null,
    };
    const refactoredNewRecord = {
        ...newRecord,
        Program: newRecord.Name,
        Name: null,
    };

    const associations: any = {
        ProductIds: {
            itemField: 'products',
            name: 'Product',
            nameResolver: (product: any) => product.name,
        },
        IndicationIds: {
            itemField: 'indications',
            name: 'Indication',
            nameResolver: (indication: any) => indication.name,
        },
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            associations,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { OrganisationProgramRecordChangeGrid };
